module.exports = __webpack_public_path__ + "static/media/tagline.ad0dd0d6.png";